import {createContext} from 'react';

const CarContext =  createContext()

// export const CarProvider = ({children}) => {
//     const [car, setCar] = useState()
//     const [order, setOrder] = useState()
//     const [campaigns, setCampaigns] = useState()

//     const providerValue = { car, setCar, order, setOrder, campaigns, setCampaigns}

//     return <CarContext.Provider value={ providerValue }>{children}</CarContext.Provider>
// };

export default CarContext